export const units = (state = [], action) => {
  if (action.type === 'FETCH_UNITS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_UNITS') {
    return [];
  }
  return state;
};

export const unit = (state = {}, action) => {
  if (action.type === 'FETCH_UNIT') {
    return action.payload;
  }
  if (action.type === 'CLEAR_UNIT') {
    return {};
  }
  return state;
};

export const unitIds = (state = [], action) => {
  if (action.type === 'FETCH_UNIT_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_UNIT_IDS') {
    return [];
  }
  return state;
};
